function formatFeedbackResponse(recommendedProducts, recommendedArticles) {
  let productFeedback = [];
  if (recommendedProducts) {
    productFeedback = recommendedProducts.map(recommendedProduct => ({
      productId: recommendedProduct.smartProductId,
      productRoutine: recommendedProduct.routineName,
      productClicked: false,
      buyNowClicked: false,
      productInView: false,
    }));
  } else {
    console.error('null state.recommendedProducts');
  }
  let articleFeedback = [];
  if (recommendedArticles) {
    articleFeedback = recommendedArticles.map(recommendedArticle => ({
      articleId: recommendedArticle.id,
      articleClicked: false,
      articleInView: false,
    }));
  } else {
    console.error('null state.recommendedArticles');
  }

  return { articles: articleFeedback, products: productFeedback };
}

function getFeedbackData(brand, locale, division, username, quizAnalysisResults, skinAnalysisResultsForML, recommendedProducts, recommendedArticles) {
  return {
    meta: {
      brand: brand,
      division,
      locale,
      username: username,
    },
    results: {
      quiz: quizAnalysisResults,
      skin: skinAnalysisResultsForML,
    },
    feedback: formatFeedbackResponse(recommendedProducts, recommendedArticles),
  };
}

function buyNowClickedData(smartId, feedbackBaseData) {
  const baseData = feedbackBaseData;
  const findProduct = baseData.feedback.products.find(data => data.productId === smartId);
  const product = { ...findProduct, buyNowClicked: true };
  const productBuyNowClicked = {
    meta: { ...baseData.meta },
    feedback: {
      products: [product],
    },
  };
  return productBuyNowClicked;
}

function productClickedData(smartId, feedbackBaseData) {
  const baseData = feedbackBaseData;
  const findProduct = baseData.feedback.products.find(data => data.productId === smartId);
  const product = { ...findProduct, productClicked: true };
  const productClicked = {
    meta: { ...baseData.meta },
    feedback: {
      products: [product],
    },
  };
  return productClicked;
}

function articleClickedData(articleId, feedbackBaseData) {
  const baseData = feedbackBaseData;
  const findArticle = baseData.feedback.articles.find(data => data.articleId === articleId);
  const article = { ...findArticle, articleClicked: true };
  const articleClicked = {
    meta: { ...baseData.meta },
    feedback: {
      articles: [article],
    },
  };
  return articleClicked;
}

export { formatFeedbackResponse, getFeedbackData, buyNowClickedData, productClickedData, articleClickedData };
